document.addEventListener("calpak:ready", () => {
  //////////////////////// View more/less products per line ///////////////////////
  let productImagesSizes;
  let monochromeProductImagesSizes;
  const filteredContainer = document.querySelector(
    ".shopify-section--product-grid:not(:has(.monochrome-product-grid))"
  );
  const monochromeFilteredContainer = document.querySelector(
    ".shopify-section--product-grid:has(.monochrome-product-grid)"
  );
  let colViewButtons = document.querySelectorAll(".col-view__button");

  if (colViewButtons.length > 0)
    colViewButtons.forEach((colViewButton) =>
      colViewButton.addEventListener("click", (e) => {
        const prnt = e.target.closest(".collection-view");
        const buttons = prnt.querySelectorAll(".col-view__button");
        const target = e.target.closest(".col-view__button");
        for (let i = 0; i < buttons.length; i++) {
          if (buttons[i] == target)
            buttons[i].setAttribute("aria-current", true);
          else buttons[i].setAttribute("aria-current", false);
        }
        const filterEl = e.target.closest(".shopify-section--col-filter");

        const allProductsImages = filteredContainer.querySelectorAll(
          ".product-unit .product-unit__image img"
        );
        if (filterEl.classList.contains("col-filter--larger-active")) {
          filterEl.classList.remove("col-filter--larger-active");
          allProductsImages.forEach((allProductsImage) =>
            allProductsImage.setAttribute("sizes", productImagesSizes)
          );
        } else {
          filterEl.classList.add("col-filter--larger-active");
          allProductsImages.forEach((allProductsImage) =>
            allProductsImage.setAttribute(
              "sizes",
              "(min-width: 901px) 33.33vw, (min-width: 651px) 50vw, 100vw"
            )
          );
        }

        if (monochromeFilteredContainer != null) {
          const allMonochromeProductsImages =
            monochromeFilteredContainer.querySelectorAll(
              ".product-unit .product-unit__image img"
            );
          if (filterEl.classList.contains("col-filter--larger-active")) {
            filterEl.classList.remove("col-filter--larger-active");
            allMonochromeProductsImages.forEach((allProductsImage) =>
              allProductsImage.setAttribute(
                "sizes",
                monochromeProductImagesSizes
              )
            );
          } else {
            filterEl.classList.add("col-filter--larger-active");
            allMonochromeProductsImages.forEach((allProductsImage) =>
              allProductsImage.setAttribute(
                "sizes",
                "(min-width: 901px) 33.33vw, (min-width: 651px) 50vw, 100vw"
              )
            );
          }
        }
      })
    );

  /////////////////////// Filter popup activators ///////////////////////
  let filterActivators = document.querySelectorAll(".filter__activator");
  if (filterActivators.length > 0) {
    filterActivators.forEach((filterActivator) =>
      filterActivator.addEventListener("click", async (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (typeof renderColorGroups === "undefined") {
          await calpak.loadScript(scripts.filter);
        }

        const filters = document.querySelector(".collection-filters");
        if (!filters.classList.contains("collection-filters--loaded")) {
          initFilter();
        }

        if (filters.classList.contains("collection-filters-banner")) {
          document
            .querySelector(".shopify-section--collection-image-banner")
            .classList.add("banner-active");
        }

        if (e.target.classList.contains("filter__activator--sort")) {
          filters.setAttribute("data-tab", "sort");
        } else {
          filters.setAttribute("data-tab", "color");
        }

        filters.activator = e.target;
        filters.setAttribute("aria-expanded", true);
        e.target.setAttribute("aria-expanded", true); // Update aria-expanded on the button
        filters.classList.add("collection-filters--active");

        const filterbanner = document.querySelector(
          ".collection-filters__control"
        );
        filterbanner.classList.add("collection-filters--open");

        const filtersection = document.querySelector(
          ".collection-filters__section"
        );
        filtersection.classList.add("filter-opened");

        // if (e.target.classList.contains("filter__activator--color")) {
        //   let colGroupButtons = document.querySelectorAll(".filt-col-group");
        //   if (colGroupButtons.length) colGroupButtons[0].focus();
        // } else {
        //   filters.focus();
        // }
      })
    );
  }

  /////////////////////// Filter collections activators ///////////////////////
  const filterCategories = document.querySelectorAll(
    "button.collections-category:not(.filter__collection__price)"
  );
  filterCategories.forEach((filterCategory) =>
    filterCategory.addEventListener("click", async (e) => {
      const target = e.target.closest(".collections-category");
      const prnt = target.closest(".collections-menu");
      const actives = prnt.querySelectorAll(".collections-category--active");
      let clickingActive = false;

      if (actives.length) {
        actives.forEach((active) => {
          if (active == target) {
            clickingActive = true;
          }
          active.classList.remove("collections-category--active");
          active.removeAttribute("aria-current");
        });
      }

      if (!clickingActive) {
        target.classList.add("collections-category--active");
        target.setAttribute("aria-current", true);
      }

      if (typeof renderColorGroups === "undefined") {
        await calpak.loadScript(scripts.filter);
      }

      //applyFilter('collections');
      filterSubCategory();
    })
  );

  // NB TODO restore filter by subcategory for fast collection loads.
  // go to https://www.calpaktravel.com/collections/organizers
  // browse filter__collections filter__collections--active slider
  const filterCollections = document.querySelectorAll(".filter__collection");
  if (filterCollections.length)
    filterCollections.forEach((filterCollection) =>
      filterCollection.addEventListener("click", async (e) => {
        const target = e.target.closest(".filter__collection");
        const dataCollection = target.getAttribute("data-collection");
        if (dataCollection == null) return;
        e.preventDefault();

        const bannerImg = document.querySelector(
          ".collection-image-banner-wrapper"
        );
        if (bannerImg) {
          bannerImg.className =
            "collection-image-banner-wrapper " + dataCollection;
        }

        target.classList.toggle("filter__collection--selected");
        const isSelected = target.classList.contains(
          "filter__collection--selected"
        );

        const searchParams = new URLSearchParams(window.location.search);
        let currentFilters = searchParams.get("sub-filter")?.split("+") || [];
        const filterHandle = target.dataset.handle;

        if (isSelected) {
          currentFilters.push(filterHandle);
        } else {
          currentFilters = currentFilters.filter((h) => h !== filterHandle);
        }

        if (currentFilters.length) {
          searchParams.set("sub-filter", currentFilters.join("+"));
        } else {
          searchParams.delete("sub-filter");
        }
        window.history.replaceState(null, null, `?${searchParams.toString()}`);

        const selectedCollections = document.querySelectorAll(
          ".filter__collection--selected"
        );
        const allProductIds = [];

        for (const collection of selectedCollections) {
          let collectionProducts = [];
          if (collection.hasAttribute("data-products")) {
            collectionProducts = collection
              .getAttribute("data-products")
              .split(",");
          } else if (collection.hasAttribute("data-collection")) {
            const collectionList = await fetch(
              `/collections/${collection.getAttribute(
                "data-collection"
              )}/products.json?limit=250`
            ).then((response) => response.json());
            collectionProducts = collectionList.products.map((p) =>
              p.id.toString()
            );
            collection.setAttribute(
              "data-products",
              collectionProducts.join(",")
            );
          }
          allProductIds.push(...collectionProducts);
        }

        const uniqueProductIds = [...new Set(allProductIds)];
        const filteredContainers = document.querySelectorAll(
          ".shopify-section--product-grid:has(.enabled-filtering)"
        );

        filteredContainers.forEach((container) => {
          let filtered = false;
          const units = container.querySelectorAll(".product-unit");

          units.forEach((product) => {
            const id = product.getAttribute("data-id");
            const shouldShow =
              selectedCollections.length === 0 || uniqueProductIds.includes(id);

            product.classList.toggle("filtered-out-subcategory", !shouldShow);
            if (!shouldShow) filtered = true;
          });

          container.classList.toggle("section-filtered-subcategory", filtered);
        });
      })
    );

  const emptyProductCount = document.querySelector(
    ".collections-category i:empty"
  );
  if (emptyProductCount) {
    emptyProductCount.innerHTML = document.querySelectorAll(
      ".product-grid .product-unit"
    ).length;
  }

  const filtersCont = document.querySelector(".collection-filters__section");
  if (filtersCont) {
    window.addEventListener("click", () => {
      const filters = document.querySelector(".collection-filters");
      if (filters.classList.contains("collection-filters-banner")) {
        document
          .querySelector(".shopify-section--collection-image-banner")
          .classList.remove("banner-active");
      }
      filters.setAttribute("aria-expanded", false);
      //filters.classList.remove('collection-filters--active');
    });

    filtersCont.addEventListener("click", (e) => e.stopPropagation());
  }
  /* removing class from quickview links: hide */
  document.querySelectorAll("a.quick-view__link").forEach((quickviewLink) => {
    quickviewLink.classList.remove("hide");
  });

  productImagesSizes = filteredContainer
    .querySelector(
      ".shopify-section--product-grid .product-unit .product-unit__image img"
    )
    ?.getAttribute("sizes");

  if (monochromeFilteredContainer != null) {
    monochromeProductImagesSizes = monochromeFilteredContainer
      .querySelector(
        ".shopify-section--product-grid .product-unit .product-unit__image img"
      )
      ?.getAttribute("sizes");
  }

  const urlParams = new URLSearchParams(window.location.search);
  const subFilters = urlParams.get("sub-filter")?.split("+") || [];
  subFilters.forEach((handle) => {
    const filter = document.querySelector(
      `.filter__collection[data-handle="${handle}"]`
    );
    if (filter && !filter.classList.contains("filter__collection--selected")) {
      filter.click();
    }
  });

  window.addEventListener("popstate", function () {
    if (location.hash !== "") return;

    const currentFilters =
      new URLSearchParams(window.location.search)
        .get("sub-filter")
        ?.split("+") || [];
    const selectedFilters = document.querySelectorAll(
      ".filter__collection--selected"
    );

    selectedFilters.forEach((filter) => {
      const handle = filter.dataset.handle;
      if (!currentFilters.includes(handle)) {
        filter.click();
      }
    });

    currentFilters.forEach((handle) => {
      const filter = document.querySelector(
        `.filter__collection[data-handle="${handle}"]`
      );
      if (
        filter &&
        !filter.classList.contains("filter__collection--selected")
      ) {
        filter.click();
      }
    });
  });
});

